let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("50o6L")).then(() => parcelRequire('k4DXB'));